export default __webpack_public_path__ + "static/media/Group 51.af6f1a34.svg";